<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="d-flex justify-content-between">
        <button @click="mtdBackRol" type="button" class="btn btn-sm text-white" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Cambiar de rol
        </button>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  name: "home-personal",
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    moment.locale("es");
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBackRol: function () {
      this.$store.commit("mt_set_rol", null);
    },
  },
};
</script>

<style lang="scss" scoped></style>
